export const categories = [
  { id: 1, name: '浪漫爱情', slug: 'romance', description: '甜蜜浪漫的韩国爱情漫画，霸道总裁、契约恋爱等热门题材', count: 48, icon: 'ri-heart-line' },
  { id: 2, name: '动作冒险', slug: 'action', description: '热血激情的韩国动作冒险漫画，战斗、冒险、成长的精彩故事', count: 35, icon: 'ri-sword-line' },
  { id: 3, name: '奇幻玄幻', slug: 'fantasy', description: '天马行空的韩国奇幻玄幻漫画，魔法、异世界、剑与魔法', count: 42, icon: 'ri-magic-line' },
  { id: 4, name: '悬疑惊悚', slug: 'thriller', description: '扣人心弦的韩国悬疑惊悚漫画，烧脑推理、心理博弈', count: 28, icon: 'ri-ghost-line' },
  { id: 5, name: '喜剧日常', slug: 'comedy', description: '轻松搞笑的韩国喜剧日常漫画，治愈减压、爆笑不断', count: 31, icon: 'ri-emotion-laugh-line' },
  { id: 6, name: '校园青春', slug: 'school', description: '青春洋溢的韩国校园漫画，纯爱、友情、成长的故事', count: 26, icon: 'ri-book-open-line' },
  { id: 7, name: '古风历史', slug: 'historical', description: '古韵悠长的韩国古风历史漫画，宫廷权谋、穿越时空', count: 22, icon: 'ri-ancient-gate-line' },
  { id: 8, name: '都市职场', slug: 'urban', description: '时尚都市的韩国职场漫画，精英对决、都市情感', count: 19, icon: 'ri-building-line' },
];

export const comics = [
  {
    id: 1,
    title: '霸道总裁的甜蜜陷阱',
    author: '金智秀',
    category: 'romance',
    categoryName: '浪漫爱情',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20romantic%20couple%20in%20elegant%20attire%2C%20soft%20pink%20and%20warm%20golden%20lighting%2C%20dreamy%20atmosphere%20with%20floating%20cherry%20blossoms%2C%20clean%20simple%20background%2C%20professional%20digital%20art%20style%2C%20Korean%20webtoon%20cover%20aesthetic&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '当冷酷无情的集团总裁遇上单纯善良的平凡女孩，一场充满算计与心动的爱情博弈就此展开。她以为只是一场交易，却不知道他早已动了真情。甜蜜与虐心交织，让人欲罢不能的浪漫故事。',
    fullDescription: '<p>当冷酷无情的集团总裁金泰亨遇上单纯善良的平凡女孩林小暖，一场充满算计与心动的爱情博弈就此展开。她以为只是一场交易，却不知道他早已动了真情。</p><p>林小暖为了偿还父亲的债务，被迫与金泰亨签订了一年的契约恋爱协议。她以为自己只是他用来应付家族催婚的棋子，但在朝夕相处中，她渐渐发现这个表面上冷漠无情的男人，其实有着一颗温柔细腻的心。</p><p>然而，当金泰亨的初恋情人突然回国，林小暖才意识到他们之间横亘着的不仅仅是身份地位的差距。甜蜜与虐心交织，让人欲罢不能的浪漫故事，带你走进霸道总裁的内心世界。</p>',
    rating: 4.8,
    views: 256000,
    updateDate: '2026-08-04',
    status: '连载中',
    tags: ['霸道总裁', '契约恋爱', '都市爱情', '甜宠'],
    chapters: 86,
  },
  {
    id: 2,
    title: '重生之逆天改命',
    author: '李恩熙',
    category: 'fantasy',
    categoryName: '奇幻玄幻',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20style%20fantasy%20illustration%20of%20a%20female%20warrior%20with%20magical%20glowing%20aura%2C%20ancient%20palace%20background%2C%20dramatic%20lighting%20with%20golden%20and%20crimson%20tones%2C%20clean%20simple%20composition%2C%20professional%20digital%20art%2C%20Korean%20webtoon%20cover%20aesthetic&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '被陷害惨死的天才魔法师，带着前世记忆重生归来。这一世，她不再任人宰割，要用绝对的实力让所有敌人付出代价。爽快的复仇剧情配合精彩的魔法战斗，让你看得停不下来。',
    fullDescription: '<p>天才魔法师柳素英被最信任的同伴陷害，惨死在禁术法阵之中。当她再次睁开眼，发现自己回到了十年前——一切都还未发生的时刻。</p><p>带着前世所有的记忆和知识，她将如何改写自己的命运？那些曾经背叛她的人，她一个都不会放过。但复仇的道路上，她意外遇见了前世的宿敌——那个传说中冷酷无情的暗黑骑士。</p><p>这一世的关系变得扑朔迷离，她才发现一切并非表面那么简单。爽快的复仇剧情、精彩的魔法战斗、意想不到的情感线，让你看得停不下来。</p>',
    rating: 4.9,
    views: 389000,
    updateDate: '2026-08-03',
    status: '连载中',
    tags: ['重生', '魔法', '复仇', '女强'],
    chapters: 124,
  },
  {
    id: 3,
    title: '我的契约恋人',
    author: '朴美妍',
    category: 'romance',
    categoryName: '浪漫爱情',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20style%20romance%20illustration%20of%20a%20couple%20standing%20back%20to%20back%20under%20starlight%2C%20soft%20blue%20and%20silver%20color%20palette%2C%20romantic%20atmosphere%2C%20clean%20simple%20background%2C%20professional%20digital%20art%2C%20Korean%20manhwa%20cover%20aesthetic&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '为了完成毕业作品，美术系学生与校草签订了为期三个月的恋爱契约。原本以为只是互相利用，却在画笔与颜料的交融中，画出了最真实的心动。温暖治愈的校园爱情故事。',
    fullDescription: '<p>美术系大三学生韩素希为了完成毕业作品《恋爱中的光影》，急需一个恋爱对象作为参考模特。机缘巧合之下，她与校园风云人物——法学系才子车银优签订了为期三个月的恋爱契约。</p><p>原本以为只是互相利用——她需要灵感，他需要摆脱追求者。然而在日复一日的相处中，在画笔与颜料的交融中，素希发现自己笔下描绘的不再只是光影，而是最真实的心动。</p><p>当契约到期的那一天来临，两颗早已靠近的心是否能够坦诚相对？温暖治愈的校园爱情故事，如同一幅水彩画般淡雅而动人。</p>',
    rating: 4.7,
    views: 198000,
    updateDate: '2026-08-02',
    status: '连载中',
    tags: ['校园爱情', '契约恋爱', '治愈', '美术'],
    chapters: 52,
  },
  {
    id: 4,
    title: '魔王的专属女仆',
    author: '郑秀晶',
    category: 'fantasy',
    categoryName: '奇幻玄幻',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20fantasy%20illustration%20of%20a%20demon%20king%20and%20a%20maid%20in%20a%20dark%20gothic%20castle%2C%20dramatic%20contrast%20between%20dark%20and%20light%2C%20mysterious%20atmosphere%2C%20clean%20simple%20background%2C%20professional%20digital%20art%2C%20Korean%20webtoon%20cover&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '阴差阳错成为魔王城堡女仆的普通人类女孩，不仅要应付喜怒无常的魔王大人，还要在各种魔界危机中求生。然而她渐渐发现，这个传说中的恐怖魔王，似乎有着不为人知的温柔一面。',
    fullDescription: '<p>普通人类女孩崔智恩在一次意外中穿越到了魔界，阴差阳错地成为了魔王城堡中唯一的人类女仆。面对喜怒无常、法力无边的魔王大人路西法，她每天都在生死边缘试探。</p><p>然而随着时间推移，她逐渐发现这个在传说中被描绘成恐怖存在的魔王，其实有着不为人知的温柔一面。他会在她受伤时默默疗伤，会在她害怕时悄悄守护。</p><p>当人类与魔界之间的战争一触即发，智恩发现自己似乎成为了两界和平的关键。而魔王大人对她的感情，也远超主仆之间的界限。</p>',
    rating: 4.6,
    views: 312000,
    updateDate: '2026-08-04',
    status: '连载中',
    tags: ['异世界', '魔王', '主仆', '奇幻爱情'],
    chapters: 98,
  },
  {
    id: 5,
    title: '暗黑学院的退学生',
    author: '崔珉豪',
    category: 'thriller',
    categoryName: '悬疑惊悚',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20dark%20thriller%20illustration%20of%20a%20mysterious%20student%20in%20a%20haunted%20academy%2C%20dark%20moody%20atmosphere%20with%20shadows%2C%20gothic%20architecture%2C%20clean%20simple%20background%2C%20professional%20digital%20art%2C%20Korean%20webtoon%20cover&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '传说中只要进入学院排名前十就会被退学——不是普通的退学，而是人间蒸发。新转学生尹在赫决心揭开暗黑学院的秘密，却发现自己的名字已经出现在那个神秘的名单上。',
    fullDescription: '<p>星辉学院是全国最顶尖的高中，但这里却流传着一个可怕的传说——每年进入学院综合排名前十的学生，都会在学期末被退学。不是普通的退学，而是彻底的人间蒸发，仿佛从未存在过。</p><p>新转学生尹在赫凭借超强的能力迅速跻身排名前十，却在深夜的图书馆里发现了一本记录了十年来所有退学生名单的册子。而他的名字，已经被添加到了名单的末尾。</p><p>为了揭开真相，尹在赫与仅剩的几位前十学生组成了秘密调查小队。然而随着调查深入，他发现学院的黑暗远超想象——幕后黑手竟然可能是他最信任的人。</p>',
    rating: 4.9,
    views: 445000,
    updateDate: '2026-08-01',
    status: '连载中',
    tags: ['悬疑', '学院', '惊悚', '推理'],
    chapters: 75,
  },
  {
    id: 6,
    title: '穿越成反派的心头宠',
    author: '韩智慧',
    category: 'fantasy',
    categoryName: '奇幻玄幻',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20girl%20in%20a%20lavish%20historical%20palace%20setting%2C%20warm%20golden%20and%20rose%20tones%2C%20elegant%20Korean%20hanbok%20style%20clothing%2C%20clean%20simple%20background%2C%20professional%20digital%20art%2C%20Korean%20webtoon%20cover&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '一觉醒来，网文作家苏小念发现自己穿越进了自己写的小说——而且成了那个注定要被反派杀死的炮灰女配。为了活命，她决定抱紧反派大腿，没想到这一抱就再也甩不掉了。',
    fullDescription: '<p>网文作家苏小念熬夜赶稿后一觉醒来，发现自己竟然穿越进了自己正在连载的小说《凤临天下》里。更糟糕的是——她穿成了书中第三章就被反派男主一巴掌拍死的炮灰女配！</p><p>面对这个杀人不眨眼的终极反派——九皇子李砚，苏小念决定发挥自己的作者优势，提前预知所有剧情走向，不惜一切代价抱紧反派大腿以求活命。她帮他避开陷阱、助他夺取皇位、替他化解危机……</p><p>然而当反派看她的眼神从冷漠变为炙热，苏小念才惊恐地发现——这个大腿好像抱得太紧了，甩都甩不掉了！而且小说的剧情已经完全偏离了她的原稿，朝着不可预测的方向狂奔而去。</p>',
    rating: 4.8,
    views: 367000,
    updateDate: '2026-08-04',
    status: '连载中',
    tags: ['穿越', '反派', '宫斗', '甜宠'],
    chapters: 110,
  },
  {
    id: 7,
    title: '公爵大人的秘密花园',
    author: '姜素拉',
    category: 'historical',
    categoryName: '古风历史',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20historical%20romance%20illustration%20of%20a%20noblewoman%20in%20a%20secret%20garden%2C%20soft%20vintage%20tones%2C%20elegant%20historical%20Korean%20setting%2C%20clean%20simple%20background%2C%20professional%20digital%20art%2C%20Korean%20webtoon%20cover&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '被家族送到公爵府做侍女的贵族之女，意外发现了公爵府后院的秘密花园。那里种满了一种只在月光下绽放的神秘花朵，而花园的主人——那位传说中冷酷无情的公爵，似乎藏着比花园更深邃的秘密。',
    fullDescription: '<p>朝鲜王朝末期，没落贵族之女尹彩英被家族送往权倾朝野的朴氏公爵府做侍女。寄人篱下的日子并不好过，直到有一天，她在深夜迷路时意外发现了公爵府后院那扇紧锁的铁门后的秘密。</p><p>那是一座只在月光下绽放的神秘花园，种满了她从未见过的奇异花卉。而花园的主人——那位传说中铁血无情、杀人如麻的朴公爵，在月光下独自照料花朵的身影，与她想象中的形象截然不同。</p><p>当她被公爵发现擅闯禁地时，她以为自己必死无疑。然而公爵却给了她一个选择：成为这座秘密花园的园丁，永远不能离开。在这个充满秘密和花香的庭院中，两颗孤独的心开始靠近。</p>',
    rating: 4.7,
    views: 234000,
    updateDate: '2026-07-30',
    status: '连载中',
    tags: ['古风', '宫廷', '秘密', '浪漫'],
    chapters: 64,
  },
  {
    id: 8,
    title: '顶楼：继承者们',
    author: '洪真英',
    category: 'urban',
    categoryName: '都市职场',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20modern%20drama%20illustration%20of%20elegant%20people%20in%20a%20luxury%20penthouse%2C%20sleek%20modern%20cityscape%20background%2C%20sophisticated%20color%20palette%2C%20clean%20simple%20background%2C%20professional%20digital%20art%2C%20Korean%20webtoon%20cover&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '韩国顶级财阀家族继承者们之间的权力游戏。在这座首尔最昂贵的顶层公寓里，每个人都在争夺家族企业的主导权。金钱、权力、爱情与背叛交织的都市传奇。',
    fullDescription: '<p>首尔江南区最昂贵的顶层公寓 Hera Palace 里，住着韩国四大财阀家族的继承人。在外人眼中，他们是含着金汤匙出生的天之骄子，但在那扇华丽的大门背后，一场残酷的权力游戏正在上演。</p><p>每个人都想成为家族企业的下一任掌门人，而在这个过程中，亲情变成了筹码，友情变成了交易，爱情变成了工具。女主韩宥利作为韩氏集团唯一的女性继承人，不仅要面对来自堂兄们的打压，还要在商场上证明自己的能力。</p><p>当她以为找到了真爱——竞争对手家族的继承人时，才发现自己陷入了一个精心设计的陷阱。在这个金钱与欲望交织的世界里，谁才是真正值得信任的人？</p>',
    rating: 4.5,
    views: 187000,
    updateDate: '2026-08-03',
    status: '连载中',
    tags: ['财阀', '权力斗争', '都市爱情', '精英'],
    chapters: 58,
  },
  {
    id: 9,
    title: '九尾狐的千年之约',
    author: '权娜拉',
    category: 'fantasy',
    categoryName: '奇幻玄幻',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20fantasy%20illustration%20of%20a%20nine-tailed%20fox%20spirit%20in%20human%20form%2C%20ethereal%20mystical%20atmosphere%2C%20moonlight%20and%20cherry%20blossoms%2C%20clean%20simple%20background%2C%20professional%20digital%20art%2C%20Korean%20webtoon%20cover&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '修行千年的九尾狐为了完成最后的渡劫，必须在现代都市中找到千年之前与她有过约定的那个人类转世。然而当她终于找到他时，却发现他已经完全不记得她——而她的时间，只剩下最后一百天。',
    fullDescription: '<p>修行千年的九尾狐白璃，距离飞升成仙只差最后一步——完成与千年前那个人类的约定。她穿越千年来到现代首尔，在一家小小的书店里找到了那个人的转世——一个叫李在旭的普通大学生。</p><p>然而令她心碎的是，他已经完全不记得千年前的任何事，甚至不相信世界上有九尾狐的存在。白璃决定用尽一切办法让他想起前世，但每一次尝试都以失败告终。</p><p>更令她绝望的是——天界给她的时间只有一百天。如果在一百天内无法完成约定，她将永远失去飞升的机会，化作山间的一缕清风。在这场与时间赛跑的旅程中，她能否唤醒他沉睡的记忆？</p>',
    rating: 4.8,
    views: 423000,
    updateDate: '2026-08-04',
    status: '连载中',
    tags: ['九尾狐', '前世今生', '奇幻爱情', '治愈'],
    chapters: 92,
  },
  {
    id: 10,
    title: '废柴逆袭：从零开始的冒险',
    author: '张东健',
    category: 'action',
    categoryName: '动作冒险',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20action%20adventure%20illustration%20of%20a%20young%20warrior%20with%20a%20sword%2C%20epic%20fantasy%20landscape%20background%2C%20dramatic%20dynamic%20composition%2C%20clean%20simple%20background%2C%20professional%20digital%20art%2C%20Korean%20webtoon%20cover&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '被称为史上最弱冒险者的金俊秀，在一次地下城探险中意外获得了传说中的无限成长系统。从此，他的冒险者等级开始疯狂飙升，而那些曾经嘲笑他的人，只能仰望他的背影。',
    fullDescription: '<p>在这个人人都具有天赋等级的世界里，金俊秀的等级被评定为 F——最弱的等级。他被冒险者公会拒之门外，被其他冒险者嘲笑为史上最弱。连最低级的史莱姆都能轻松打败他。</p><p>然而在一次被迫参与的地下城清理任务中，他不慎跌入了最底层的深渊，却意外触发了传说中的无限成长系统——一个能够无限提升使用者能力的远古神器。</p><p>从此，他的冒险者等级开始以不可思议的速度飙升。F 级、E 级、D 级……当那些曾经嘲笑他的人还在原地踏步时，他已经站在了他们永远无法企及的高度。但力量的背后，也隐藏着巨大的代价。</p>',
    rating: 4.6,
    views: 298000,
    updateDate: '2026-08-02',
    status: '连载中',
    tags: ['系统', '升级', '冒险', '逆袭'],
    chapters: 135,
  },
  {
    id: 11,
    title: '夜行书生的血色浪漫',
    author: '申世京',
    category: 'historical',
    categoryName: '古风历史',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20dark%20historical%20illustration%20of%20a%20mysterious%20scholar%20in%20traditional%20Korean%20clothing%20at%20night%2C%20moonlight%20and%20shadows%2C%20gothic%20romantic%20atmosphere%2C%20clean%20simple%20background%2C%20professional%20digital%20art%2C%20Korean%20webtoon%20cover&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '朝鲜时代，一位神秘的书生只在夜间出没于汉阳城的街头巷尾。坊间传闻他是吸血鬼，但只有他知道，自己追寻的是一个跨越百年的血色承诺。当一位勇敢的女医师闯入他的世界，他尘封的心开始动摇。',
    fullDescription: '<p>朝鲜正祖年间，汉阳城流传着一个诡异的传闻：每当夜幕降临，一位身着素白书生袍的男子便会出现在街头巷尾。有人说他是含冤而死的鬼魂，有人说他是吸食人血的怪物。</p><p>实际上，他叫李贤，曾经是成均馆最优秀的儒生，却因为一个无法违背的承诺，在世间徘徊了一百多年。他白天沉睡，夜晚出没，守护着这座城市免受邪祟侵扰。</p><p>直到那天夜里，一位名叫许烟雨的女医师在救治病人时无意中撞见了他。她是第一个不害怕他的人，也是第一个让他想要打破诅咒、重新变回人类的人。但打破诅咒的代价——是付出他永生不死的生命。</p>',
    rating: 4.7,
    views: 276000,
    updateDate: '2026-07-29',
    status: '连载中',
    tags: ['古风', '吸血鬼', '浪漫', '悬疑'],
    chapters: 71,
  },
  {
    id: 12,
    title: '皇后的复仇攻略',
    author: '崔秀英',
    category: 'historical',
    categoryName: '古风历史',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20historical%20drama%20illustration%20of%20a%20queen%20in%20royal%20palace%20attire%2C%20regal%20and%20powerful%20presence%2C%20deep%20red%20and%20gold%20tones%2C%20clean%20simple%20background%2C%20professional%20digital%20art%2C%20Korean%20webtoon%20cover&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '被最信任的妹妹和丈夫联手背叛，皇后柳慈恩含恨而死。当她再次睁开眼，发现自己回到了三年前——大婚当日。这一世，她不再是那个天真善良的皇后，而是携着满腔仇恨归来的复仇者。',
    fullDescription: '<p>柳慈恩是大康王朝的皇后，十年来兢兢业业辅佐皇帝，却被自己最信任的亲妹妹和最爱的丈夫联手毒杀。临死前，她才知道自己的家族被满门抄斩，而这一切的幕后黑手，正是她日夜守护的枕边人。</p><p>含恨而死之后，她再次睁开了眼睛——发现自己回到了三年前，大婚当日。这一世，她不再是那个天真善良、任人宰割的皇后。她要用这三年的时间，一步步瓦解敌人的势力，让所有背叛她的人付出代价。</p><p>然而在复仇的道路上，她意外发现前世的许多真相并非表面那般简单。而她与皇帝之间的感情，似乎也有着不为人知的隐情。当真相与仇恨交织，她该如何抉择？</p>',
    rating: 4.9,
    views: 512000,
    updateDate: '2026-08-04',
    status: '连载中',
    tags: ['重生', '复仇', '宫斗', '女强'],
    chapters: 142,
  },
  {
    id: 13,
    title: '社内相亲：契约婚姻',
    author: '李侑菲',
    category: 'urban',
    categoryName: '都市职场',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20modern%20romance%20illustration%20of%20a%20couple%20in%20business%20attire%20in%20a%20modern%20office%2C%20bright%20clean%20corporate%20setting%2C%20warm%20professional%20atmosphere%2C%20clean%20simple%20background%2C%20professional%20digital%20art%2C%20Korean%20webtoon%20cover&width=400&height=560&seq=comic-cover-13&orientation=portrait',
    description: '被家人逼迫相亲的职场精英申夏琳，灵机一动找了自己的下属假扮男友。没想到这个临时男友不仅是公司隐藏的太子爷，还打算把这场戏演一辈子。甜蜜又搞笑的办公室恋情就此展开。',
    fullDescription: '<p>三十岁的申夏琳是 JK 集团最年轻的市场部经理，事业有成但感情空白。在家人第 N 次安排相亲后，她灵机一动——找了自己的得力下属金珉奎假扮男友，打算先应付过去再说。</p><p>然而她不知道的是，这个平时话不多、工作勤恳的老实下属，其实是 JK 集团会长的独生子——隐姓埋名在公司从基层做起。当他被拉去假扮男友时，他决定将计就计。</p><p>从假扮情侣到一起出差、从公司年会的意外公开到家人的突然催婚——这场原本只是做戏的关系，在不知不觉中变得越来越真实。当真相揭开的那一刻，申夏琳才发现自己早已深陷其中。</p>',
    rating: 4.6,
    views: 215000,
    updateDate: '2026-08-01',
    status: '连载中',
    tags: ['办公室恋情', '契约婚姻', '喜剧', '甜宠'],
    chapters: 48,
  },
  {
    id: 14,
    title: '剑与魔法的幻想曲',
    author: '朴叙俊',
    category: 'action',
    categoryName: '动作冒险',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20epic%20fantasy%20illustration%20of%20a%20knight%20fighting%20a%20dragon%2C%20epic%20battle%20scene%2C%20dramatic%20lighting%20and%20dynamic%20action%2C%20clean%20simple%20background%2C%20professional%20digital%20art%2C%20Korean%20webtoon%20cover&width=400&height=560&seq=comic-cover-14&orientation=portrait',
    description: '在一个剑与魔法并存的世界里，少年剑士李浩然踏上了寻找传说中永恒之剑的旅程。一路上他结识了各怀绝技的伙伴，共同对抗即将苏醒的远古邪龙。热血与友情交织的史诗冒险。',
    fullDescription: '<p>阿尔卡迪亚大陆上，剑与魔法并存，人类、精灵、矮人三大种族共同生活在这片广袤的土地上。然而和平的假象即将被打破——沉睡千年的远古邪龙暗翼正在苏醒。</p><p>少年剑士李浩然出身于一个偏远的小村庄，却有着不为人知的血脉传承。当村庄遭到魔物袭击时，他被神秘的老剑圣所救，并得知自己是唯一能够驾驭永恒之剑的人选。</p><p>为了在邪龙完全苏醒前找到永恒之剑，李浩然踏上了跨越整个大陆的冒险之旅。一路上他结识了精灵族的女弓箭手、矮人族的锻造大师、还有一位身份成谜的黑魔法师。在这个充满危险与奇迹的世界中，友情是最强大的魔法。</p>',
    rating: 4.5,
    views: 178000,
    updateDate: '2026-07-28',
    status: '连载中',
    tags: ['剑与魔法', '冒险', '友情', '热血'],
    chapters: 103,
  },
  {
    id: 15,
    title: '月光下的秘密',
    author: '金裕贞',
    category: 'thriller',
    categoryName: '悬疑惊悚',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20mystery%20illustration%20of%20a%20woman%20looking%20through%20a%20window%20at%20night%2C%20mysterious%20moonlight%2C%20tense%20atmosphere%2C%20psychological%20thriller%20vibe%2C%20clean%20simple%20background%2C%20professional%20digital%20art%2C%20Korean%20webtoon%20cover&width=400&height=560&seq=comic-cover-15&orientation=portrait',
    description: '每个月的月圆之夜，首尔江南区某栋公寓楼里就会发生一起失踪事件。刑警韩智慧调查此案时，发现所有失踪者都有一个共同点——他们都收到过一张没有署名的邀请函。而下一个收到邀请函的人，正是她自己。',
    fullDescription: '<p>首尔江南区，连续六个月来，每到月圆之夜就有人离奇失踪。失踪者来自不同年龄、不同职业，唯一的共同点是——他们都住在同一栋公寓楼里。</p><p>刑警韩智慧接手此案后，调查进展缓慢。直到她在分析所有失踪者的社交记录时发现了一个惊人的共同点：每个人在失踪前三天，都收到过一张没有署名的黑色邀请函，上面只有一句话——月光之下，真相大白。</p><p>就在她即将找到突破口时，一张同样的黑色邀请函出现在她的办公桌上。发件人似乎对她的每一步行动都了如指掌。而在追踪这个神秘发件人的过程中，韩智慧发现自己与这栋公寓楼之间，有着她一直刻意遗忘的联系。</p>',
    rating: 4.7,
    views: 356000,
    updateDate: '2026-08-03',
    status: '连载中',
    tags: ['悬疑', '推理', '刑警', '心理'],
    chapters: 67,
  },
  {
    id: 16,
    title: '天命之子的归来',
    author: '宋仲基',
    category: 'action',
    categoryName: '动作冒险',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20action%20illustration%20of%20a%20powerful%20warrior%20returning%20with%20divine%20light%2C%20epic%20heroic%20pose%2C%20dramatic%20golden%20lighting%2C%20clean%20simple%20background%2C%20professional%20digital%20art%2C%20Korean%20webtoon%20cover&width=400&height=560&seq=comic-cover-16&orientation=portrait',
    description: '十年前被封印到异次元的天命之子终于打破了封印归来。然而他曾经守护的世界已经面目全非——邪恶势力统治了大陆，曾经的伙伴四散天涯。他要用绝对的力量夺回属于这个世界的一切。',
    fullDescription: '<p>十年前，被誉为天命之子的少年英雄韩宇辰在与魔王的大决战中，牺牲自己将魔王连同自己一起封印在了异次元裂缝之中。大陆迎来了短暂的和平，人们为他立起了雕像，歌颂他的英勇事迹。</p><p>然而十年后，封印被不知名的力量打破，韩宇辰从异次元中归来。但他发现，自己拼命守护的世界已经面目全非——新的黑暗势力趁他不在时统治了大陆，曾经并肩作战的伙伴们四散天涯、生死不明。</p><p>在异次元中磨炼了十年的他，拥有了远超从前的力量。但这一次，他要面对的不只是强大的敌人，还有人心的背叛、信任的崩塌。那些曾经高举他旗帜的人，如今却成了他最危险的敌人。</p>',
    rating: 4.8,
    views: 389000,
    updateDate: '2026-08-04',
    status: '连载中',
    tags: ['热血', '归来', '战斗', '英雄'],
    chapters: 118,
  },
  {
    id: 17,
    title: '恋爱副本通关指南',
    author: '金赛纶',
    category: 'comedy',
    categoryName: '喜剧日常',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20comedy%20illustration%20of%20a%20girl%20surrounded%20by%20game-like%20love%20elements%2C%20bright%20colorful%20vibrant%20style%2C%20playful%20atmosphere%2C%20clean%20simple%20background%2C%20professional%20digital%20art%2C%20Korean%20webtoon%20cover&width=400&height=560&seq=comic-cover-17&orientation=portrait',
    description: '游戏宅女李多喜某天醒来发现自己的生活变成了一个恋爱养成游戏。每个异性头顶都飘着好感度数值，日常任务变成了约会挑战。作为一个资深游戏玩家，她决定用游戏攻略的方式来通关现实恋爱。结果嘛——现实比游戏难多了！',
    fullDescription: '<p>李多喜是个不折不扣的游戏宅，玩过的恋爱养成游戏不下百款，攻略过各种性格的二次元男主。然而现实中，她的恋爱经验为零。</p><p>某天早晨醒来，她发现自己眼前出现了一个半透明的游戏界面——每个异性头顶都飘着好感度数值，日常任务变成了「与咖啡店店员进行一次超过三分钟的对话」或「在图书馆偶遇心仪对象」。更离谱的是，她还能看到各种隐藏的攻略路线。</p><p>作为一个资深游戏玩家，多喜信心满满地开始运用自己丰富的游戏经验来攻略现实中的恋爱。然而现实远比游戏复杂——没有存档点、不能重来、NPC（普通人）的行为完全不可预测！一场啼笑皆非的现实版恋爱攻略就此展开。</p>',
    rating: 4.4,
    views: 156000,
    updateDate: '2026-08-02',
    status: '连载中',
    tags: ['喜剧', '系统', '恋爱', '搞笑'],
    chapters: 45,
  },
  {
    id: 18,
    title: '丧尸末日：幸存者日记',
    author: '马东锡',
    category: 'thriller',
    categoryName: '悬疑惊悚',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20post-apocalyptic%20illustration%20of%20survivors%20in%20a%20zombie%20outbreak%2C%20dark%20desolate%20cityscape%2C%20tense%20survival%20atmosphere%2C%20clean%20simple%20background%2C%20professional%20digital%20art%2C%20Korean%20webtoon%20cover&width=400&height=560&seq=comic-cover-18&orientation=portrait',
    description: '一场突如其来的丧尸病毒席卷了首尔。普通上班族金道贤在末日中艰难求生，用日记记录下每一天的绝望与希望。当他以为人类已经失去全部希望时，他在废墟中遇见了一群同样在寻找生机的幸存者。',
    fullDescription: '<p>2026 年，一场突如其来的丧尸病毒从首尔地铁站开始蔓延。短短 72 小时内，这座两千多万人的超级都市变成了一座死亡之城。</p><p>普通上班族金道贤侥幸躲过了第一波感染潮，躲在自己位于江南区的小公寓里。没有超能力，没有特种兵训练，他只是一个再普通不过的年轻人。在绝望中，他开始写日记——记录每一天的食物搜寻、每一次与丧尸的擦肩而过、每一个独自度过的漫漫长夜。</p><p>就在他快要撑不下去的时候，他在一座废弃的超市里遇到了另外一群幸存者——一个带着孩子的母亲、一个失去队友的警察、一个沉默寡言的高中生。在这个人类文明崩塌的世界里，他们成为了彼此的家人。但末日中最大的威胁，有时候并不是丧尸。</p>',
    rating: 4.6,
    views: 267000,
    updateDate: '2026-08-01',
    status: '连载中',
    tags: ['丧尸', '末日', '生存', '人性'],
    chapters: 82,
  },
  {
    id: 19,
    title: '星光下的约定',
    author: '裴秀智',
    category: 'school',
    categoryName: '校园青春',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20youth%20romance%20illustration%20of%20two%20students%20under%20a%20starry%20night%20sky%2C%20warm%20nostalgic%20atmosphere%2C%20school%20rooftop%20setting%2C%20clean%20simple%20background%2C%20professional%20digital%20art%2C%20Korean%20webtoon%20cover&width=400&height=560&seq=comic-cover-19&orientation=portrait',
    description: '天文社唯一的两个成员——理性冷静的学霸李星辰和天马行空的艺术生林小星，因为学校的废社危机被迫联手。在无数个仰望星空的夜晚，两个性格迥异的少年少女，许下了属于青春的约定。',
    fullDescription: '<p>银河高中天文社因为成员不足面临废社危机——整个社团只剩下两个成员：理性冷静的学霸李星辰和天马行空的艺术生林小星。一个把天文当成严谨的科学，一个把星空当成浪漫的灵感来源。</p><p>为了避免废社，两人不得不联手举办招新活动。在这个过程中，星辰教会了小星认识星座的准确位置，而小星则教会了星辰如何用艺术的眼光欣赏星空。从最初的互不对付，到渐渐习惯彼此的陪伴。</p><p>学校天台上那架老旧的天文望远镜，见证了无数个只属于他们的星空夜晚。当流星雨划过天际的那个夜晚，星辰终于鼓起勇气，说出了那句藏在心底很久的话。青春的故事，就像星光一样，温柔而坚定。</p>',
    rating: 4.7,
    views: 189000,
    updateDate: '2026-08-03',
    status: '连载中',
    tags: ['校园', '青春', '浪漫', '天文'],
    chapters: 40,
  },
  {
    id: 20,
    title: '她来自深渊',
    author: '郑有美',
    category: 'thriller',
    categoryName: '悬疑惊悚',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20dark%20fantasy%20illustration%20of%20a%20mysterious%20girl%20emerging%20from%20darkness%2C%20haunting%20beautiful%20atmosphere%2C%20contrast%20between%20light%20and%20shadow%2C%20clean%20simple%20background%2C%20professional%20digital%20art%2C%20Korean%20webtoon%20cover&width=400&height=560&seq=comic-cover-20&orientation=portrait',
    description: '在深海研究站工作的一支科考队，从马里亚纳海沟的最深处打捞上来了一个密闭的金属舱。当舱门被打开时，里面躺着一个昏迷的人类女孩。她看起来不过十七八岁——但碳定年检测显示，这个金属舱在海底已经沉睡了超过一万年。',
    fullDescription: '<p>太平洋马里亚纳海沟，深度 11034 米。一支国际深海科考队在例行探测中，发现了一个不应该存在于此的东西——一个闪烁着微弱蓝光的密闭金属舱。</p><p>当科考队将金属舱打捞上来并打开时，所有人都震惊了：舱内躺着一个看似十七八岁的亚洲面孔少女，处于深度休眠状态。更令人难以置信的是，初步碳定年检测显示，这个金属舱在海底已经沉睡了超过一万年。</p><p>少女被送往秘密研究机构进行观察。当她醒来后，表现出了超乎寻常的智慧和能力，却对自己的来历三缄其口。负责与她沟通的研究员韩博士逐渐发现，这个自称「渊」的少女，似乎在寻找什么东西——不，是在躲避什么东西。而那个东西，正从万米深的海底缓慢上升。</p>',
    rating: 4.8,
    views: 334000,
    updateDate: '2026-08-04',
    status: '连载中',
    tags: ['科幻', '悬疑', '深海', '神秘'],
    chapters: 55,
  },
];

export const faqs = [
  { question: '韩漫漫画网是什么？', answer: '韩漫漫画网是一个专注于韩国漫画在线阅读的中文平台，提供海量免费韩漫资源，涵盖浪漫爱情、动作冒险、奇幻玄幻、悬疑惊悚等多种类型，为广大韩漫爱好者提供优质的在线阅读体验。' },
  { question: '网站上的漫画都是免费的吗？', answer: '是的，韩漫漫画网上所有漫画作品均为免费阅读。我们致力于为广大漫画爱好者提供无障碍的阅读体验，让更多人能够享受韩国漫画的魅力。' },
  { question: '如何找到我想看的漫画？', answer: '您可以通过首页的分类导航浏览不同题材的漫画，也可以使用搜索功能直接查找您感兴趣的漫画名称。网站首页还提供了热门推荐、最新更新和排行榜等功能，帮助您快速发现优质漫画。' },
  { question: '漫画多久更新一次？', answer: '不同漫画的更新频率有所不同，大多数连载中的漫画保持每周更新的节奏。您可以在每部漫画的详情页查看具体的更新状态和最新更新时间。' },
  { question: '网站支持手机阅读吗？', answer: '韩漫漫画网采用响应式设计，完美适配桌面端、平板和手机等各类设备，让您随时随地畅享韩漫阅读。' },
  { question: '如何联系我们？', answer: '您可以通过关于我们页面的联系方式与我们取得联系，包括电子邮箱、社交媒体账号等渠道。我们非常重视每一位读者的反馈和建议。' },
];

export const testimonials = [
  { name: '漫画迷小林', content: '韩漫漫画网的分类系统太赞了！找漫画特别方便，而且每天都有更新提醒，再也不会错过喜欢的作品了。', rating: 5 },
  { name: '资深读者小张', content: '作为追了五六年韩漫的老读者，这个网站的资源丰富程度让我惊喜。界面简洁清爽，阅读体验特别流畅。', rating: 5 },
  { name: '新入坑的小王', content: '朋友推荐的韩漫漫画网，一下就被吸引了！画质清晰，更新快，推荐功能也很准，发现了好多宝藏漫画。', rating: 5 },
  { name: '学生党小李', content: '全免费的漫画网站真的太难得了！而且没有烦人的广告弹窗，阅读体验比很多付费平台都好。强烈推荐！', rating: 5 },
];